module.exports = "/images/casquette.png?b51c136e3a01f6db379af65d3313d3f3";